import { request } from '@/requests/default'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export type Tenant = {
  id: string
  insurer_id: string
  application_name: string | null
  logo: string
  favicon: string
  domain: string
  subdomain_slug: string
  subdomain_url: string
  auth_page_image_url: string | null
  social_media_links: {
    facebook: string
    instagram: string
    twitter: string
    linkedin: string
    youtube: string
  }
}

export const useTenantStore = defineStore('tenant', () => {
  const tenant = ref<Tenant | null>(null)

  async function fetchTenant() {
    const data = await request({
      url: '/api/tenant-branding',
      method: 'GET',
    })

    tenant.value = data

    if (tenant.value?.favicon) {
      setTenantFavicon()
    }
  }

  function setTenantFavicon() {
    const links = document.querySelectorAll("link[rel~='icon']")
    links.forEach((link) => link?.parentNode?.removeChild(link))

    const newLink = document.createElement('link')
    newLink.rel = 'icon'
    newLink.href = tenant.value?.favicon as string
    newLink.type = 'image/png'
    document.head.appendChild(newLink)
  }

  const hasCustomDomain = computed(() => isUsingCustomDomain())

  const tenantLogo = computed(() => {
    return tenant.value?.logo
  })

  const authPageImageUrl = computed(() => {
    return tenant.value?.auth_page_image_url
  })

  function isUsingCustomDomain() {
    return tenant.value?.domain || tenant.value?.subdomain_slug
  }

  return {
    tenant,
    fetchTenant,
    isUsingCustomDomain,
    tenantLogo,
    setTenantFavicon,
    hasCustomDomain,
    authPageImageUrl,
  }
})
